export default __webpack_public_path__ + "assets/nepal-flag.png";